export default "__VITE_ASSET__CkfegiPX__"